var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "stop-list-widget border rounded-plus p-3 mr-1" },
    [
      _vm.is_load
        ? _c(
            "div",
            {
              staticClass: "d-flex justify-content-center mb-3 mt-3 pt-3 pb-3",
            },
            [
              _c("b-spinner", {
                attrs: { variant: "success", label: "Loading..." },
              }),
            ],
            1
          )
        : _c("div", { staticClass: "chart" }, [
            _c(
              "div",
              { staticClass: "stat-grid mb-4" },
              _vm._l(_vm.statCards, function (stat) {
                return _c("div", { key: stat.key, staticClass: "stat-card" }, [
                  _c(
                    "div",
                    {
                      staticClass: "stat-card__icon",
                      class: "bg-" + stat.color + "-50",
                    },
                    [
                      _c("i", {
                        staticClass: "fal",
                        class: [stat.icon, "color-" + stat.color + "-500"],
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-card__body" }, [
                    _c("span", { staticClass: "stat-card__label" }, [
                      _vm._v(_vm._s(stat.label)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "stat-card__value",
                        class: "color-" + stat.color + "-500",
                      },
                      [_vm._v(_vm._s(stat.value))]
                    ),
                  ]),
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chart-card" },
              [
                _c("highcharts", {
                  attrs: { options: _vm.chartOptions, highcharts: _vm.char3d },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.summary.total_in_stop > 0
              ? _c("div", { staticClass: "mt-4" }, [
                  _c("div", { staticClass: "d-flex align-items-center mb-2" }, [
                    _c("i", { staticClass: "fal fa-history mr-2 opacity-50" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "fs-sm fw-500 opacity-75" }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.__t("STOP_LIST_LONGEST")) +
                          "\n\t\t\t\t"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.longest_items.length > 0
                    ? _c("div", { staticClass: "table-responsive" }, [
                        _c(
                          "table",
                          {
                            staticClass: "table table-sm stop-list-table mb-0",
                          },
                          [
                            _c("thead", [
                              _c("tr", { staticClass: "fs-xs opacity-50" }, [
                                _c("th", { staticClass: "rank-col" }),
                                _vm._v(" "),
                                _c("th", [_vm._v(_vm._s(_vm.__t("PRODUCT")))]),
                                _vm._v(" "),
                                _c("th", [
                                  _vm._v(_vm._s(_vm.__t("RESTAURANT"))),
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "text-right" }, [
                                  _vm._v(
                                    _vm._s(_vm.__t("STOP_LIST_DURATION_SHORT"))
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(_vm.longest_items, function (row, idx) {
                                return _c("tr", { key: "item_" + row.id }, [
                                  _c("td", { staticClass: "rank-col" }, [
                                    _c("span", { staticClass: "rank-badge" }, [
                                      _vm._v(_vm._s(idx + 1)),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-truncate",
                                      staticStyle: { "max-width": "180px" },
                                    },
                                    [_vm._v(_vm._s(row.title))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-truncate opacity-75",
                                      staticStyle: { "max-width": "140px" },
                                    },
                                    [_vm._v(_vm._s(row.restaurant.title))]
                                  ),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge rounded-pill bg-danger-50 color-danger-500 duration-badge",
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(row.duration_human) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        ),
                                      ]
                                    ),
                                  ]),
                                ])
                              }),
                              0
                            ),
                          ]
                        ),
                      ])
                    : _c("div", { staticClass: "fs-sm opacity-50" }, [
                        _vm._v(
                          "\n\t\t\t\t" + _vm._s(_vm.__t("NO_DATA")) + "\n\t\t\t"
                        ),
                      ]),
                ])
              : _vm._e(),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }